"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = require("react");

var _styles = require("./styles");

var _stripeJs = require("@stripe/stripe-js");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _utils = require("./utils");

var _Card = require("../../atoms/Card");

var _Loading = require("../../atoms/Loading");

var _check_circle = _interopRequireDefault(require("../../../assets/images/defaultImages/check_circle.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var stripeApiKey = (0, _stripeJs.loadStripe)("".concat(process.env.REACT_APP_KEY_STRIPE));

var CardSelector = function CardSelector(_ref) {
  var jwt = _ref.jwt,
      setCard = _ref.setCard,
      setStripe = _ref.setStripe,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _onClick = _ref.onClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stripeLoaded = _useState2[0],
      setStripeLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      cards = _useState4[0],
      setCards = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedCard = _useState6[0],
      setSelectedCard = _useState6[1];

  var loadStripeJS = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var cardsResponse;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return stripeApiKey;

            case 2:
              setStripeLoaded(true);
              _context.next = 5;
              return (0, _utils.getAllCards)(jwt);

            case 5:
              cardsResponse = _context.sent;
              setCards(cardsResponse);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadStripeJS() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    // loadStripeJS();
    stripeApiKey.then(function () {
      setStripeLoaded(true);
      (0, _utils.getAllCards)(jwt).then(function (cardsResponse) {
        setCards(cardsResponse);
      });
    });
  }, []);
  return stripeLoaded ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    isSelected: isSelected,
    onClick: function onClick() {
      return _onClick && _onClick();
    },
    children: [isSelected ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _check_circle.default,
      alt: "Seleccionado"
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: "Tarjetas guardadas"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactStripeJs.Elements, {
      stripe: stripeApiKey,
      children: cards.map(function (card) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.Card, {
          card: card,
          selectedCard: selectedCard,
          setSelectedCard: setSelectedCard,
          setCard: setCard,
          setStripe: setStripe
        }, card.id);
      })
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {});
};

exports.CardSelector = CardSelector;